import {
    AmountConditionType,
    DateConditionType,
    FormRuleConditionType,
    TransactionRuleConditionFormSchema,
} from "./constants";
import { conditionFormRowToModel } from "./formToModel.helpers";

function isCompleteCondition(condition: TransactionRuleConditionFormSchema) {
    if (condition.conditionType === FormRuleConditionType.BANK_DESCRIPTION) {
        return (
            Boolean(condition.descriptionValue?.length) &&
            condition.descriptionValue?.every(
                (value) => value.trim().length > 0,
            )
        );
    }
    if (condition.conditionType === FormRuleConditionType.AMOUNT) {
        switch (condition.amountConditionType) {
            case AmountConditionType.IS_NOT_ROUND:
                return true;
            case AmountConditionType.IS_ROUND:
                return condition.amountRoundingLevel !== undefined;
            case AmountConditionType.BETWEEN:
                return (
                    condition.amountValueRange?.min !== undefined &&
                    condition.amountValueRange.max !== undefined &&
                    Number.isFinite(condition.amountValueRange.min) &&
                    Number.isFinite(condition.amountValueRange.max) &&
                    condition.amountValueRange.min <=
                        condition.amountValueRange.max
                );
            default:
                return Number.isFinite(condition.amountSingleValue);
        }
    }
    if (condition.conditionType === FormRuleConditionType.DATE) {
        switch (condition.dateConditionType) {
            case DateConditionType.BETWEEN:
                return Boolean(
                    condition.dateValueRange?.after &&
                    condition.dateValueRange.before,
                );
            case DateConditionType.AFTER:
                return Boolean(condition.dateValueRange?.after);
            case DateConditionType.BEFORE:
                return Boolean(condition.dateValueRange?.before);
        }
    }
    const model = conditionFormRowToModel(condition);
    return (
        model !== undefined &&
        (!Array.isArray(model.value) || model.value.length > 0)
    );
}

export function hasCompleteExplicitConditions(
    conditions: TransactionRuleConditionFormSchema[],
) {
    return (
        conditions.some(
            (condition) =>
                condition.conditionType !== FormRuleConditionType.ENTITY,
        ) && conditions.every(isCompleteCondition)
    );
}
